import React from 'react'
import { Table } from 'react-bootstrap'
import { formato_monto } from '../../common/Formatos'

const AmparosCasoTable = ({ data }) => {

    if (!data || data.length === 0) {
        return <span style={{ display: 'inherit', textAlign: 'center' }}>No hay registros encontrados.</span>
    }

    const total = data.reduce((sum, row) => sum + (Number(row.monto) || 0), 0)

    return (
        <Table striped bordered className="customTable">
            <thead>
                <tr>
                    <th>Amparo</th>
                    <th style={{ textAlign: 'center' }}>Monto</th>
                    <th style={{ textAlign: 'center' }}>Estado</th>
                    <th style={{ textAlign: 'center' }}>Fecha Registro</th>
                    <th style={{ textAlign: 'center' }}>Usuario Registro</th>
                </tr>
            </thead>
            <tbody>
                {data.map((row, index) => (
                    <tr key={index}>
                        <td>{row.nombreCobertura}</td>
                        <td style={{ textAlign: 'right' }}>{formato_monto(row.monto)}</td>
                        <td style={{ textAlign: 'center' }}>{row.estado || ''}</td>
                        <td style={{ textAlign: 'center' }}>{row.fechaRegistro || ''}</td>
                        <td style={{ textAlign: 'center' }}>{row.usuario || ''}</td>
                    </tr>
                ))}
                <tr>
                    <td style={{ fontWeight: 'bold' }}>Total Amparos Caso</td>
                    <td style={{ textAlign: 'right', fontWeight: 'bold' }}>{formato_monto(total)}</td>
                    <td colSpan={3}></td>
                </tr>
            </tbody>
        </Table>
    )
}

export default AmparosCasoTable
